import { useEffect, useState } from 'react';
import Pagination from '../../../shared/components/Pagination';
import { useParams, useSearchParams } from 'react-router-dom';
import { postMABAA090 } from '../../../services/Api';
import { formatDate, formatNumberWithCommas } from '../../../utils';

const MABAA090 = () => {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});

    useEffect(() => {
        postMABAA090(id, { page })
            .then(({ data }) => {
                setPages(data.info);
                setData(data.data);
            })
            .catch((error) => console.log(error));
    }, [id, page]);
    return (
        <div className="profile-content">
            <div className="title-profile">배너 등록 내역</div>
            <div id="profile-continuous-recruitment-advertising">
                <div className="profile-content-count">
                    총 <span className="total">{formatNumberWithCommas(pages?.totalRow || 0)}</span>건
                </div>
                <table className="table-gray">
                    <thead>
                        <tr>
                            <th style={{ width: '5%' }} />
                            <th style={{ width: '35%' }}>상품명</th>
                            <th style={{ width: '8%' }}>시작일</th>
                            <th style={{ width: '8%' }}>마감일</th>
                            <th style={{ width: '9%' }}>S/V일수</th>
                            <th style={{ width: '6%' }}>조회수</th>
                            <th style={{ width: '6%' }}>마감여부</th>
                            <th style={{ width: '8%' }}>등록비</th>
                            <th style={{ width: '6%' }}>입금여부</th>
                            <th style={{ width: '18%' }}>Comment</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.length > 0 ? (
                            data.map((item, index) => {
                                const startDateFormat = item?.startDate ? formatDate(item?.startDate) : '';
                                const endDateFormat = item?.endDate ? formatDate(item?.endDate) : '';
                                const costFormat = item?.cost ? formatNumberWithCommas(item?.cost) : 0;
                                return (
                                    <tr key={index}>
                                        <td>{item.seq}</td>
                                        <td>{item?.goodName}</td>
                                        <td>{startDateFormat}</td>
                                        <td>{endDateFormat}</td>
                                        <td>{item?.duration}</td>
                                        <td>{item?.visitedCnt}</td>
                                        <td>{item?.isEnd}</td>
                                        <td>{costFormat}</td>
                                        <td>{item?.ipGumCheck}</td>
                                        <td>{item?.comment}</td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={10}>데이타가 없습니다.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <Pagination pages={pages} />
        </div>
    );
};
export default MABAA090;
